import type { DocMigration } from "../docMigration";
import { forEachRoom } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_43: DocMigration = {
  maxSchemaVersion: "0.0.43",
  apply(json: any) {
    forEachRoom(json, (room) => {
      if (room.layout && room.layout.elevationNotes) {
        for (const note of room.layout.elevationNotes) {
          if (note && note.mirrorWithBuilding === undefined) {
            note.mirrorWithBuilding = true;
          }
        }
      }
    });
    return json;
  },
};

export default migration_0_0_43;
